
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";



import * as React from "react";
import {GroupProperties} from "InternalShared/PageBuilder/Controls/Properties/styles/GroupProperties";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {DimensionStyleSet} from "InternalShared/PageBuilder/Controls/Properties/StyleSets/DimensionStyleSet";
import {NumberProperty} from "InternalShared/PageBuilder/Controls/Properties/NumberProperty";
import {ColorProperty} from "InternalShared/PageBuilder/Controls/Properties/ColorProperty";
import {ButtonProperties} from "InternalShared/PageBuilder/Controls/Properties/ButtonProperties";
import {FieldsProperty} from "InternalShared/PageBuilder/Controls/Properties/FieldsProperty";
import {AllowedResizeDirection} from "InternalShared/Dto";
import {ImageProperty} from "InternalShared/PageBuilder/Controls/Properties/ImageProperty";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {IconDialog} from "PageBuilder/Dialogs/IconDialog";
import {IconControlOptions, IconData} from "./IconControl.Options";
import {IconProperty} from "InternalShared/PageBuilder/Controls/Properties/IconProperty";
import {IconStyleProperty} from "InternalShared/PageBuilder/Controls/Properties/IconStyleProperty";


declare let rednaoPDFInvoiceParams:any;
export class IconControl extends PDFControlBase{
    public Options:IconControlOptions;
    public AllowedResizeDirection:AllowedResizeDirection="none";
    GetInitialOptions(): Promise<PDFControlBaseOptions> {
        return new Promise(async resolve => {
            let icon:IconData=await Dialog.Show(<IconDialog/>);
            resolve(new IconControlOptions().Merge({
                IconData:icon
            }))
        });
    }

    GetProperties(): GroupProperties[] {
        return [
            new GroupProperties('General').AddProperties([
                new IconProperty(this,"IconData"),
                new IconStyleProperty(this,'IconStyle',null).SetLabel('Style')
            ])
        ];
    }

    GetStyles(): GroupProperties[] {
        return [
            DimensionStyleSet.GetStyles(this),
            new GroupProperties('Icon Styles').AddProperties([
                new NumberProperty(this,'FontSize').SetLabel('Font Size'),
                new ColorProperty(this,'Color').SetLabel('Color'),
            ])
        ];
    }


    SetInitialStyles() {
        this.StyleManager.AddStyleSet('span',{'vertical-align':'middle'})
    }

    protected InternalGenerateHtml($container: JQuery<HTMLElement>) {
        let size=parseInt(this.Options.FontSize);
        if(isNaN(size))
            size=20;
        let icon=jQuery(`<span style="vertical-align: top;font-family: ${this.Options.IconData.Font};">${this.Options.IconData.Value}</span>`);
        let text:any;
        if(this.Options.IconStyle==null||this.Options.IconStyle=="basic")
        {
            icon.attr('style',icon.attr('style')+'font-size:'+size+'px !important;color:'+this.Options.Color+' !important;');
            text=icon;
        }

        if(this.Options.IconStyle=="round"||this.Options.IconStyle=="square")
        {
            icon.attr('style',icon.attr('style')+`font-size:${Math.ceil(size*.63)}px !important;line-height: ${Math.ceil(size*.63)}px !important;color:#FFFFFF !important;`);
            icon.css({position:'absolute',top:0,left:0});
            icon.css({opacity:1});
            jQuery('body').append(icon);
            let height=icon.outerHeight();
            let width=icon.outerWidth();
            this.Options.OuterHeight=height;
            this.Options.OuterWidth=width;
            icon.css('top',size/2-height/2).css('left',size/2-width/2);

            text=jQuery(`<div style="width:${size}px;height:${size}px;position: relative; "></div>`);
            text.append(icon);
            let $imageData;
            if(this.Options.IconStyle=="round")
                $imageData= btoa('<svg width="100px" height="100px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="'+this.Options.Color+'"><circle cx="50" cy="50" r="50"  /></svg>');
            else
                $imageData= btoa('<svg height="100px"  fill="'+this.Options.Color+'"  width="100px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><rect width="100%" height="100%" /></svg>');
            this.Options.Data=$imageData;
            let $image=jQuery(`<img style="width:${size}px;height:${size}px"></img>`);
            $image.attr('src','data:image/svg+xml;base64,'+
                $imageData);
            text.prepend($image);
        }

        $container.append(text);
    }


}
